import { render, staticRenderFns } from "./DrugStore.vue?vue&type=template&id=0ff6c99e&lang=pug&"
import script from "./DrugStore.vue?vue&type=script&lang=ts&"
export * from "./DrugStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports